'use client';

import { Loading } from '@castlery/fortress';

export const ProductCollectionSectionLoading = () => {
  return <Loading theme="dark" />;
};
